import Locale from "../../locale/Locale";
import React from "react";

export default class AlertHelper {

    static translateAlertType(type) {
        switch(type) {
            case "PUMP_DRIVE":
                return Locale.gettext("Pump drive error");
            case "SALT_CHLORINATOR":
                return Locale.gettext("Salt chlorinator issue");
            case "LONG_DISCONNECTED":
              return Locale.gettext("Long disconnected");
            case "UNSTABLE_DEVICE":
                return Locale.gettext("Unstable device");
            case "NOT_RESPONDING":
                return Locale.gettext("Device not responding");
            case "ACTUATOR_NOT_TURNING":
                return Locale.gettext("Actuator not turning");
            case "ACTUATOR_CONTINUALLY_TURNING":
                return Locale.gettext("Actuator continually Turning");
            case "NOT_UP_TO_SPEED":
                return Locale.gettext("Pump not up to speed");
            case "CHEMICALS_NOT_WORKING":
                return Locale.gettext("Chemistry dosing issue");
            case "MANUAL_TEST_REQUIRED":
                return Locale.gettext("Manual testing required");
            case "LOW_SALT":
                return Locale.gettext("Low salt level");
            case "FILTER_CLOGGED":
                return Locale.gettext("Filter clogged");
            case "THERMISTOR_ERROR":
                return Locale.gettext("Problem with a thermistor");
            case "NO_WATER_FILTERED":
                return Locale.gettext("Water not filtered recently");
            case "MAX_BODY_OF_WATER_FILL_VOLUME":
                return Locale.gettext("Maximum fill volume exceeeded");
            case "CONFIGURATION_ISSUE":
                return Locale.gettext("Attendant configuration issue");
            case "AMBIENT_TEMP_ERROR":
                return Locale.gettext("Ambient temperature problem");
            case "ACTUATOR_FAILED_TO_TURN":
                return Locale.gettext("Actuator failing to turn");
            case "ACTUATOR_SECONDARY_OFFLINE":
                return Locale.gettext("Secondary Attendant is offline");
            case "ACTUATOR_OVERCURRENT":
                return Locale.gettext("Actuator overcurrent");
            case "ACTUATOR_STOPPED_TOO_SOON":
                return Locale.gettext("Actuator stopping too soon");
            case "COLD_WATER":
                return Locale.gettext("Water is too cold");
            case "DOOR_LEFT_OPEN":
                return Locale.gettext("Attendant door left open");
            case "FREE_CHLORINE_HIGH":
                return Locale.gettext("Free chlorine levels too high");
            case "FREE_CHLORINE_LOW":
                return Locale.gettext("Free chlorine levels too low");
            case "HEATER":
                return Locale.gettext("Problem with heater");
            case "HEAT_PUMP":
                return Locale.gettext("Problem with heat pump");
            case "MCU_NOT_FOUND":
                return Locale.gettext("MCU board not found");
            case "NO_FLOW":
                return Locale.gettext("No flow or very low flow detected");
            case "ORP_HIGH":
                return Locale.gettext("ORP reading too high");
            case "ORP_LOW":
                return Locale.gettext("ORP reading too low");
            case "PH_HIGH":
                return Locale.gettext("pH reading too high");
            case "PH_LOW":
                return Locale.gettext("pH reading too low");
            case "TOTAL_CHLORINE_HIGH":
                return Locale.gettext("Total chlorine levels too high");
            case "TOTAL_CHLORINE_LOW":
                return Locale.gettext("Total chlorine levels too low");
            case "VERY_LOW_SALT":
                return Locale.gettext("Very low salt level");
            case "WATER_LEVEL":
                return Locale.gettext("Problem with water level");
            case "PUMP_INTERLOCKED_DUE_TO_WATER_LEVEL_SENSOR":
                return Locale.gettext("Interlocked pump disabled");
            default:
                return type;
        }
    }



    static getDetails(config, alert) {
        let body = config.BodiesOfWater?.find(itm => itm.UUID === alert.bodyUuid) ||
                    config.BodiesOfWater?.find(itm => itm.UUID === alert.entityUuid);
        let device = config.Devices?.find(dev => dev.UUID === alert.entityUuid) || 
                    config.BodiesOfWater?.find(dev => dev.UUID === alert.entityUuid);
        if (alert.type === "LONG_DISCONNECTED") {
            device = { Name: Locale.gettext("Attendant") };
            return {
                short: Locale.gettext("Attendant was not seen for more then a day."),
                long: ( alert.data?.lastSeen ? Locale.gettext("Last seen at: ", Locale.formatDateTime(alert.data.lastSeen)) : "" )
            };
        }
        if (!device) {
            device = { Name: Locale.gettext("Unknown Device") };
        }
        if (alert.type === "NO_WATER_FILTERED") {
            return {
                short: Locale.gettext("The body %1$s was not filtered recently.", body?.Name || Locale.gettext("Unknown Body")),
                long: Locale.gettext("A filter schedule may need to be created.")
            }
        }
        if (alert.type === "NOT_RESPONDING") {
            return {
                short: Locale.gettext("Device %1$s is not responding.", device.Name),
                long: Locale.gettext("Please check configuration, wiring, or try to reset it.")
            };
        }
        if (alert.type === "ACTUATOR_NOT_TURNING") {
            return {
                short: Locale.gettext("Actuator %1$s is not turning.", device.Name),
                long: Locale.gettext("Please check wiring, and if the switch on the actuator is in the current position.")
            };
        }
        if (alert.type === "ACTUATOR_CONTINUALLY_TURNING") {
            return {
                short: Locale.gettext("Actuator %1$s is continually spinning.", device.Name),
                long: Locale.gettext("Detected at %1$s. The motor has slipped a gear, the wire to the actuator has shorted or the calibration is off.", Locale.formatDateTime(alert.data?.ErrorDateTime))
            };
        }
        if (alert.type === "NOT_UP_TO_SPEED") {
            return {
                short: Locale.gettext("%1$s Was not able to react the desired speed.", device.Name),
                long: Locale.gettext("The desired speed of %2$s%% for %1$s was never reached. The current speed is %3$s%%.", 
                    device.Name,
                    alert.data?.DesiredSpeed,
                    alert.data?.ActualSpeed
                )
            };
        }
        if (alert.type === "CHEMICALS_NOT_WORKING") {
            if (device.ChemicalType === 'CHLORINE') {
                return {
                    short: Locale.gettext("Failed to dose chlorine for %1$s.", body.Name),
                    long: Locale.gettext("We tried to increase the chlorine but didn't detect a change in Orp when dosing was attempted.") + " " +
                            Locale.gettext("Check to make sure your chlorine tank is full and the pump is working. If that is ok, the next step is to troubleshoot your probe.")
                };
            } else if (device.ChemicalType === 'MURATIC_ACID') {
                return {
                    short: Locale.gettext("Failed to adjust %1$s pH.", body.Name),
                    long: Locale.gettext("We tried to adjust the pH but didn't detect a change in pH when dosing was attempted.") + " " +
                            Locale.gettext("Check to make sure your acid tank is full and the pump is working. If that is ok, the next step is to troubleshoot your probe.")
                };
            }
            return {
                short: Locale.gettext("Dosing error"),
                long: ""
            };
        }
        if (alert.type === "MANUAL_TEST_REQUIRED") {
            return {
                short: Locale.gettext("Water test required"),
                long: Locale.gettext("Please perform a manual test.")
            };
        }
        if (alert.type === "FILTER_CLOGGED") {
            return {
                short: Locale.gettext("Clogged equipment"),
                long: Locale.gettext("We have detected that your equipment is getting clogged. First check for debris in your skimmer basket or pump basket. If those are clear, it is time to backwash or clean your filter.")
            };
        }
        if (alert.type === "PUMP_DRIVE") {
            return {
                short: this.translateAlertType(alert.type),
                long: this.getPumpDriveDescription(alert.data)
            };
        }
        if (alert.type === "THERMISTOR_ERROR") {
            return {
                short: this.translateAlertType(alert.type),
                long: this.getThermistorErrorDescription(alert, device)
            };
        }
        if (alert.type === "LOW_SALT") {
            return {
                short: this.translateAlertType(alert.type),
                long: this.getLowSaltErrorDescription(alert, device)
            };
        }
        if (alert.type === "SALT_CHLORINATOR") {
            return {
                short: this.translateAlertType(alert.type),
                long: this.getSaltChlorinatorErroDescription(alert)
            };
        }
        if (alert.type === "UNSTABLE_DEVICE") {
            return {
                short: Locale.gettext("%1$s is reading unstable values.", device.Name),
                long: Locale.gettext("Please check the wiring connections.")
            };
        }
        if (alert.type === "CONFIGURATION_ISSUE") {
            return {
                short: Locale.gettext("Configuration Issue"),
                long: Locale.gettext("There is an issue with the configuration of %1$s.", device.Name)
            };
        }
        if (alert.type === "AMBIENT_TEMP_ERROR") {
            return {
                short: Locale.gettext("Ambient Temperature Problem"),
                long: Locale.gettext('No ambient temperature sensor is connected to the system. If you have an ambient temperature sensor please check the connection.') + 
                        Locale.gettext('No current weather data has been downloaded to your system, please check your internet connection.')
            };
        }

        return {
            short: this.translateAlertType(alert.type),
            long: Locale.gettext("Created at %1$s", Locale.formatDateTime(alert.created))
        };
    }

    static getPumpDriveDescription(alertData) {
        let errorDescription = Locale.gettext("Unknown error %1$s", alertData.DriveErrorState);
        let errorDescription2 = "";
        let resetPump = Locale.gettext(
            'Please follow these steps to reset the pump.'
            + '\n• Shut off the breaker.'
            + '\n• Wait 1 minute.'
            + '\n• Turn the breaker back on.'
            + '\nThe pump should now resume normal operation.'
        );
        switch (alertData.DriveErrorState) {
            case "STALLED": errorDescription = Locale.gettext("The drive is reporting: Stalled"); break;
            case "HEATSINK_OVERHEAT": errorDescription = Locale.gettext("The drive is reporting: Heatsink overheated"); break;
            case "OVERCURRENT": errorDescription = Locale.gettext('The drive is reporting: Overcurrent'); break;
            case "POWER_OUT": errorDescription = Locale.gettext('The drive is reporting: Power out'); break;
            case "PRIMING_DRY": errorDescription = Locale.gettext('The drive is reporting: Primming dry'); break;
            case "INVALID_SPEED_SETTINGS": errorDescription = Locale.gettext('Restore configured minimum and maximum settings to factory defaults.'); break;
            case "PRESSURE_LIMIT": errorDescription = Locale.gettext('Pressure Limit'); break;
            case "DC_VOLTAGE_HIGH":
                errorDescription = Locale.gettext('DC Voltage High');
                errorDescription2 = resetPump;
                break;
            case "DC_VOLTAGE_LOW":
                errorDescription = Locale.gettext('DC Voltage Low');
                errorDescription2 = resetPump;
                break;
            case "DRIVE_OVERHEAT": errorDescription = Locale.gettext('Drive is overheated'); break;
            case "STOP_BUTTON_PRESSED": errorDescription = Locale.gettext('The Stop Button Has Been Pressed'); break;
            case "PROCESSOR": errorDescription = Locale.gettext('The drive is reporting: Processor'); break;
            case "KEYPAD": errorDescription = Locale.gettext('The drive is reporting: Keypad'); break;
            case "DATA_FLASH": errorDescription = Locale.gettext('The drive is reporting: Data flash'); break;
            case "LOW_POWER": errorDescription = Locale.gettext('The drive is reporting: Low power'); break;
            case "LOSS_OF_PHASE": errorDescription = Locale.gettext('The drive is reporting: Loss of phase'); break;
            case "SVRS": errorDescription = Locale.gettext('Safety Vacuum Release Systems'); break;
            case "UNKNOWN":
            default:
                errorDescription = (alertData.ErrorCode ? 
                    Locale.gettext("The drive is reporting an unknown error of %1$s.", alertData.ErrorCode) :
                    Locale.gettext("The drive is reporting an unknown error.")
                )
                + (alertData.DriveErrorState && alertData.DriveErrorState !== 'UNKNOWN' ? ' ' + Locale.gettext('Error state: %s.', alertData.DriveErrorState) : '')
                + ' ' + Locale.gettext('Please review the device screen for more details.');
                break;
            }
        return errorDescription;
    }

    static getThermistorErrorDescription(alert, device) {
        let detailDescription = '';
        const port = device.HardwareDevice?
                    '(Thermistor port: ' + device.HardwareDevice?.Ports[0]?.Number + ')':
                    '';
        switch (alert.data?.ErrorState) {
            case 'TOO_LOW':
                detailDescription = Locale.gettext('The temperature sensor on port %1$s is reading too low %2$s.',
                    port,
                    Locale.formatTemperature(alert.data?.TemperatureF)
                ); break;
            case 'TOO_HIGH':
                detailDescription = Locale.gettext('The temperature sensor on port %1$s is reading too high %2$s.',
                    port,
                    Locale.formatTemperature(alert.data?.TemperatureF)
                ); break;
            default:
                break;
        }

        let detailDescription2 = '';
        switch (alert.data?.ErrorState) {
            case 'TOO_LOW':
                detailDescription2 = Locale.gettext('This could mean the sensor has failed, it is not plugged in or the wire could be cut.'); break;
            case 'TOO_HIGH':
                detailDescription2 = Locale.gettext('This could mean the sensor has failed, the wire has been cut and it\'s been shorted or the wire has been cut and is in direct sunlight.'); break;
            default:
                break;
        }
        return detailDescription + " " + detailDescription2;
    }

    static getLowSaltErrorDescription(alert, device) {
        let detailDescription = Locale.gettext('%1$s%2$s is currently reading %3$s for it\'s salt level.',
            device.Name,
            device.HardwareDevice?.UniqueBusIdentifier ?
                ' (Serial port: ' + device.HardwareDevice?.Ports[0]?.Number + ', Bus ID : ' + device.HardwareDevice?.UniqueBusIdentifier + ')' :
                '',
            alert.data?.ActualSaltLevel
        );
        let detailDescription2 = Locale.gettext('The recommended level of salt is %s.',
            alert.data?.DesiredMinimumSaltLevel
        );
        return detailDescription + " " + detailDescription2;
    }

    static getSaltChlorinatorErroDescription(alert) {
        const errors = [];
        if (alert.data?.ErrorStates) {
            Object.entries(alert.data.ErrorStates).forEach(([ key, val ]) => {
                switch (key) {
                case "LOW_SALT": errors.push(
                    Locale.gettext("The device is reporting: Low Salt.\nFirst reported at: %s", Locale.formatDateTime(new Date(val)))
                ); break;
                case "INSPECT_CELL": errors.push(
                    Locale.gettext("The device is reporting: Inspect Cell.\nFirst reported at: %s", Locale.formatDateTime(new Date(val)))
                ); break;
                case "HIGH_SALT": errors.push(
                    Locale.gettext("The device is reporting: High Salt.\nFirst reported at: %s", Locale.formatDateTime(new Date(val)))
                ); break;
                case "POWER_OUT": errors.push(
                    Locale.gettext("The device is reporting: Power Out.\nFirst reported at: %s", Locale.formatDateTime(new Date(val)))
                ); break;
                case "NO_FLOW_WHILE_GENERATING": errors.push(
                    Locale.gettext("The device is reporting: No Flow While Generating.\nFirst reported at: %s", Locale.formatDateTime(new Date(val)))
                ); break;
                default: 
                    errors.push(
                        Locale.gettext("The device is reporting: %s.\nFirst reported at: %s", key, Locale.formatDateTime(new Date(val)))
                    ); break;
                }
            });
        }

        return errors.join(" ");
    }
}